import Qs from 'query-string'

import initialFilters from 'lib/filters'
import { SALE_CAMPAIGNS } from 'utils/checkCampaign'
import { reverseFiltersDictionary, filtersDictionary } from './dictionaries'
import { parseToNumber } from '../../utils/parseNumbers'

const isCampaignChecked = campaigns => {
  return campaigns && Object.values(campaigns).some(campaign => campaign)
}

const extractSelectedCampaigns = (campaigns, separator = '--') => {
  const campaignKeys = Object.keys(campaigns)
  let extractedCampaigns = ''

  const adjustCampaignToApi = campaign => {
    if (separator === ',') {
      if (
        (SALE_CAMPAIGNS.blackoutDay.test(process.env.REACT_APP_CAMPAIGN) &&
          campaign === 'campaign') ||
        (SALE_CAMPAIGNS.blackoutDay.test(
          process.env.REACT_APP_SECOND_CAMPAIGN
        ) &&
          campaign === 'secondCampaign')
      ) {
        return 'corujao'
      }

      if (
        (SALE_CAMPAIGNS.blackout.test(process.env.REACT_APP_CAMPAIGN) &&
          campaign === 'campaign') ||
        (SALE_CAMPAIGNS.blackout.test(process.env.REACT_APP_SECOND_CAMPAIGN) &&
          campaign === 'secondCampaign')
      ) {
        return 'cashback'
      }
    }

    if (campaign === 'campaign') {
      return filtersDictionary[process.env.REACT_APP_CAMPAIGN]
    }

    return filtersDictionary[process.env.REACT_APP_SECOND_CAMPAIGN]
  }

  campaignKeys.forEach(campaign => {
    const campaignName = adjustCampaignToApi(campaign)
    if (campaigns[campaign]) {
      if (!extractedCampaigns.length) {
        extractedCampaigns += campaignName
      } else {
        extractedCampaigns += `${separator}${campaignName}`
      }
    }
  })
  return extractedCampaigns
}

export const parseQueryString = myFilters => {
  const {
    searchId,
    valueRange,
    visits,
    selectedLocalities,
    noLegalActions,
    noDebts,
    filters,
    page,
    orderBy,
    surroundingsSearch,
    campaigns,
  } = myFilters

  let url = '?'

  if (selectedLocalities.length > 0 && selectedLocalities[0]) {
    url = url.concat(
      `&search=${selectedLocalities.map(locality => locality.slug).toString()}`
    )
  }
  if (searchId) {
    url = url.concat(`&id-banco=${searchId}`)
  }

  if (isCampaignChecked(campaigns)) {
    url = url.concat(
      `&campanha-exclusiva=${extractSelectedCampaigns(campaigns, ',')}`
    )
  }

  if (valueRange) {
    const { max, min } = valueRange
    if (min > 0) {
      url = url.concat(`&valor-min=${min}`)
    }
    if (max !== 5000000) {
      url = url.concat(`&valor-max=${max}`)
    }
  }
  if (visits) {
    url = url.concat(`&permite-visita=sim`)
  }
  if (surroundingsSearch) {
    url = url.concat(`&buscar-regiao=sim`)
  }
  if (surroundingsSearch) {
    url = url.concat(`&buscar-regiao=sim`)
  }
  if (noLegalActions) {
    url = url.concat(`&possui-acao-judicial=nao`)
  }
  if (noDebts) {
    url = url.concat(`&possui-dividas=nao`)
  }
  if (orderBy) {
    url = url.concat(`&order=${orderBy}`)
  }
  if (page > 1) {
    url = url.concat(`&page=${page}`)
  }

  if (filters) {
    Object.keys(filters).forEach(filter => {
      const currentFilter = filters[filter]
      if (!Array.isArray(currentFilter)) {
        return
      }
      let firstParam = true
      currentFilter.forEach(opt => {
        if (opt.checked) {
          if (firstParam) {
            url = url.concat(`&${reverseFiltersDictionary[filter]}=`)
            url = url.concat(`${opt.value}`)
            firstParam = false
          } else {
            url = url.concat(`,${opt.value}`)
          }
        }
      })
    })
  }

  return url
}

export const filterProfiles = [
  {
    name: 'starter',
    rules: {
      [filtersDictionary['tipo-imovel']]: ['Apartamento', 'Casa', 'Terreno'],
      [filtersDictionary['tipo-venda']]: ['venda_direta', 'imobiliaria'],
      noLegalActions: true,
      discountParam: 10,
    },
  },
  {
    name: 'experienced',
    rules: {
      discountParam: 20,
    },
  },
  {
    name: 'risky',
    rules: {
      discountParam: 30,
    },
  },
  {
    name: 'home',
    rules: {
      visits: true,
      noLegalActions: true,
      desagio: 0,
      [filtersDictionary['tipo-imovel']]: ['Apartamento', 'Casa'],
      [filtersDictionary.situacao]: ['Desocupado'],
      [filtersDictionary['tipo-venda']]: ['venda_direta', 'imobiliaria'],
    },
  },
].reduce(
  (profileObj, currProfileObj) => ({
    ...profileObj,
    [currProfileObj.name]: Qs.stringify(currProfileObj.rules, {
      arrayFormat: 'bracket',
    }),
  }),
  {}
)
export const sanitizeFilter = filter => {
  if (!Object.keys(filter).length) return null

  const {
    initialValueRange: { min: minLimit, max: maxLimit },
  } = initialFilters

  const filterData = Object.keys(filter)[0]
  const sanit = {
    visits: filter.visits && { [filtersDictionary.visits]: 'sim' },
    noDebts: filter.noDebts && { [filtersDictionary.noDebts]: 'sim' },
    noLegalActions: filter.noLegalActions && {
      [filtersDictionary.noLegalActions]: 'sim',
    },
    surroundingsSearch: filter.surroundingsSearch && {
      [filtersDictionary.surroundingsSearch]: 'sim',
    },
    orderBy: filter.orderBy !== 'data' && {
      [filtersDictionary.orderBy]: [filtersDictionary[filter.orderBy]],
    },
    campaigns: filter.campaigns &&
      isCampaignChecked(filter.campaigns) && {
        [filtersDictionary.campaign]: extractSelectedCampaigns(
          filter.campaigns
        ),
      },
    page: filter.page > 1 && { [filtersDictionary.page]: filter.page },
    searchId: filter.searchId && {
      [filtersDictionary.searchId]: filter.searchId,
    },
    desagio: !filter.slug &&
      filter.desagio && {
        [filtersDictionary.discountParam]: filter.desagio,
      },
    selectedVendorId: filter.selectedVendorId && {
      [filtersDictionary.vendedor]: [
        filtersDictionary[filter.selectedVendorId],
      ],
    },
    valueRange: filter.valueRange &&
      (filter.valueRange.min > minLimit ||
        filter.valueRange.max < maxLimit) && {
        valor: `${filter.valueRange.min}-${filter.valueRange.max}`,
      },
  }

  return sanit[filterData] || filtersDictionary[filter]
}

export function parseSanitizeUrl(filter, variable, prev) {
  const parse = {
    searchId: variable || prev.searchId,
    visits: (variable === 'sim' && true) || prev.visits,
    noDebts: (variable === 'sim' && true) || prev.noDebts,
    noLegalActions: (variable === 'sim' && true) || prev.noLegalActions,
    surroundingsSearch: (variable === 'sim' && true) || prev.surroundingsSearch,
    orderBy: reverseFiltersDictionary[variable] || prev.orderBy,
    page: Number(variable) || prev.page,
  }

  if (filter === 'Desagio') {
    if (variable !== undefined) {
      return parseInt(variable || prev.desagio, 10)
    }
    return null
  }

  if (filter === 'valueRange') {
    return {
      min: variable
        ? parseInt(variable.split('-')[0], 10)
        : prev.valueRange.min,
      max: variable
        ? parseInt(variable.split('-')[1], 10)
        : prev.valueRange.max,
    }
  }

  if (filter === 'campaigns') {
    const newState = { ...prev.campaigns }
    if (variable) {
      if (variable instanceof Array) {
        variable.forEach(campaign => {
          if (reverseFiltersDictionary[campaign]) {
            newState[reverseFiltersDictionary[campaign]] = true
          }
        })
      } else if (reverseFiltersDictionary[variable]) {
        newState[reverseFiltersDictionary[variable]] = true
      }
    }

    return newState
  }

  if (filter === 'apiFilters') {
    const apiFilterKeys = Object.keys(variable || {})
    const apiFilters = variable

    const parseFilters = {}

    if (apiFilterKeys.length) {
      apiFilterKeys.forEach(apiFilterKey => {
        const key = reverseFiltersDictionary[apiFilterKey]
        let value
        if (Array.isArray(apiFilters[apiFilterKey])) {
          value = []
          apiFilters[apiFilterKey].map(apiFilterValue => {
            // eslint-disable-next-line no-param-reassign
            apiFilterValue =
              apiFilterValue instanceof Object
                ? apiFilterValue[apiFilterKey]
                : apiFilterValue
            return value.push(reverseFiltersDictionary[apiFilterValue])
          })
        } else {
          value = reverseFiltersDictionary[apiFilters[apiFilterKey]]
          value = value instanceof Object ? value[apiFilterKey] : value
        }
        Object.assign(parseFilters, {
          [key]: value,
        })
      })
    }

    return parseFilters
  }
  return parse[filter] || reverseFiltersDictionary[filter]
}

/**
 * It receives prevFilter from storage and returns the newFilter to be sent to storage with the proper field toggled and all others unChecked
 * @param {array} prevFilter
 * @param {string} fieldValue
 * @returns newFilter
 * @author Leandro Parisi
 */
export const uniqueCheckboxesToggler = (prevFilter, fieldValue) => {
  const fieldIndex = prevFilter.findIndex(field => field.value === fieldValue)

  const newField = {
    ...prevFilter[fieldIndex],
    checked: !prevFilter[fieldIndex].checked,
  }

  const newUncheckedFields = prevFilter
    .filter(field => field.value !== fieldValue)
    .map(field => ({ ...field, checked: false }))

  const newFilter = [...newUncheckedFields]

  newFilter.splice(fieldIndex, 0, newField)

  return newFilter
}
export const onChangeMin = (newMinValue, valueRange) => {
  const minValue = parseToNumber(newMinValue)
  const newValue = valueRange
  const {
    initialValueRange: { step },
  } = initialFilters

  if (minValue > valueRange.max - step) {
    newValue.min = valueRange.max - step
  } else {
    newValue.min = Number(minValue)
  }
  return newValue
}

export const onChangeMax = (newMaxValue, valueRange) => {
  const maxValue = parseToNumber(newMaxValue)
  const newValue = valueRange
  const {
    initialValueRange: { step },
  } = initialFilters

  if (maxValue < valueRange.min + step) {
    newValue.max = Number(valueRange.min) + step
  } else {
    newValue.max = Number(maxValue)
  }
  return newValue
}
